module.exports = __webpack_public_path__ + "static/media/electric.e2592861.svg";